import React from "react";

/**
 * 需要实现的功能
 * 1. 图片懒加载
 * 2. 外部链接跳转确认
 * 3. 过滤掉script
 */
interface RickTextProps {
    children?: string;
    className?: string;
}

export default function RickText({ children, className }: RickTextProps) {
    return (
        <div
            className={className}
            dangerouslySetInnerHTML={{ __html: children || "" }}
        />
    );
}
